import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  richTextOverride: {
    position: 'relative',
    zIndex: '3',
    color: '#000000',
    display: 'none',
    [theme.breakpoints.down('md')]: {
      color: '#fff',
      display: "none",
      paddingBottom: pxToRem(24)
    }
  }
}));

export default useStyles;
